import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hr from "./locales/hr.json";

export const LANGUAGE_STORAGE_KEY = "preferred_language";
export const DEFAULT_LANGUAGE = "hr";
export const SUPPORTED_LANGUAGES = ["hr", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const getStoredLanguage = (): SupportedLanguage => {
	try {
		const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
		if (stored === "en" || stored === "hr") {
			return stored;
		}
	} catch {
		// localStorage may be unavailable in some environments
	}
	return DEFAULT_LANGUAGE;
};

const initialLanguage = getStoredLanguage();
document.documentElement.lang = initialLanguage;

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: en },
		hr: { translation: hr },
	},
	lng: initialLanguage,
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
